import { render, staticRenderFns } from "./productSelectionPopup.vue?vue&type=template&id=054a9a37&"
import script from "./productSelectionPopup.vue?vue&type=script&lang=js&"
export * from "./productSelectionPopup.vue?vue&type=script&lang=js&"
import style0 from "./productSelectionPopup.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports